/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

interface ChatIconProps {
  size?: number
  color?: string
  style?: SerializedStyles
  className?: string
}

/**
 * Chat icon component - displays a chat bubble icon
 */
const ChatIcon: React.FC<ChatIconProps> = ({
  size = 24,
  color = colors.NEUTRAL_50,
  style,
  className,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={size}
      viewBox='0 -960 960 960'
      width={size}
      fill={color}
      css={style}
      className={className}
    >
      <path d='M880-80 720-240H320q-33 0-56.5-23.5T240-320v-40h440q33 0 56.5-23.5T760-440v-280h40q33 0 56.5 23.5T880-640v560ZM160-473l47-47h393v-280H160v327ZM80-280v-520q0-33 23.5-56.5T160-880h440q33 0 56.5 23.5T680-800v280q0 33-23.5 56.5T600-440H240L80-280Zm80-240v-280 280Z' />
    </svg>
  )
}

export default ChatIcon
